module.exports = __webpack_public_path__ + "img/moneyBill.c9c60047.svg";